import { tGlobal } from '../services/translation';
import { Button } from './buttons/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from './dialog';

type ModalSubscriptionSuccessProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
};

export function ModalSubscriptionSuccess(props: ModalSubscriptionSuccessProps) {
  const { open, onOpenChange, title, description } = props;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hasCloseButton>
        <img src="/box-paperPlane.png" alt="trial-subscription" className="mb-4 w-full" />
        <DialogTitle align="center">{title}</DialogTitle>
        <DialogDescription align="center">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </DialogDescription>
        <DialogFooter>
          <Button
            size="xl"
            variant="accent"
            className="w-full"
            onClick={() => void onOpenChange(false)}
          >
            {tGlobal('ok')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
